import { Component, Input } from '@angular/core';
import Check from 'framework/Check';
import MerchantFieldLabelMap from 'app/models/typescript/MerchantFieldLabelMap';
import Utils from '../../../shared/utils';
import { MerchantFieldsService } from '../../../services/merchant-fields.service';
import { finalize, forkJoin } from 'rxjs';

@Component({
	selector: 'app-components-managecustomer-merchantfieldsedit',
	templateUrl: './MerchantFieldsEdit.component.html'
})
export class MerchantFieldsEditComponent implements IActivatable {
    public title = 'Partner - Edit Merchant Fields';
    isLoading = false;
    merchantFieldLabelMap: MerchantFieldLabelMap;
    merchantFields: Boo.Objects.CustomerMerchantFields;
    merchantSitePublishDate: KnockoutObservable<moment.Moment> = ko.observable();
    protected priorityViewApi: app.interfaces.IPriorityViewPublicApi;

    constructor(private merchantFieldsService: MerchantFieldsService) { }

    canActivate(user: Boo.Objects.User, partner: Boo.Objects.Partner, params: app.managecustomer.interfaces.IMerchantFieldsEditParams): boolean {
        Check.isNotEmpty(params.customerId, 'customerId cannot be empty');
        Check.isNotEmpty(params.partnerId, 'partnerId cannot be empty');
        Check.isNotEmpty(params.priorityViewApi, 'Priority view api is missing');
        this.isLoading = true;
        this.priorityViewApi = params.priorityViewApi;
        forkJoin({
            mapping: this.merchantFieldsService.generateLabelMapping(params.partnerId), 
            merchantFields: this.merchantFieldsService.get(params.customerId)
        })
        .pipe(finalize(() => this.isLoading = false))
        .subscribe(response => {
            this.merchantFieldLabelMap = response.mapping;
            this.merchantFields = response.merchantFields;
            this.merchantSitePublishDate(moment(response.merchantFields.MerchantSitePublishDate));
        });

        return _.any(user.PartnerUsers, (partnerUser: Boo.Objects.PartnerUser) => {
            // User has a customer service user and not readonly then they can edit merchant fields
            return partnerUser.UserLevelId === Boo.Objects.Enums.UserLevelEnum.CustomerService && partnerUser.IsReadonly === false;
        });
    }

    save() {
        this.isLoading = true;
        this.merchantFields.MerchantSitePublishDate = this.merchantSitePublishDate().isValid() ? this.merchantSitePublishDate().toDate() : null;

        this.merchantFieldsService.save(this.merchantFields)
        .pipe(finalize(() => this.isLoading = false))
        .subscribe({
            next: () => this.priorityViewApi.resolve(),
            error: err => toastr.error(err)
        });
    }

    close() {
        this.priorityViewApi.reject();
    }
}
